import React from 'react'
import PropTypes from 'prop-types'

const View = ({ children, ...otherProps }) => (
  <div className="view" {...otherProps}>
    {children}
  </div>
)

View.propTypes = {
  children: PropTypes.any.isRequired,
}

export default View



// WEBPACK FOOTER //
// ./src/browser/components/View.js